import script from "./OrderList.vue?vue&type=script&lang=ts&setup=true&name=OrderList"
export * from "./OrderList.vue?vue&type=script&lang=ts&setup=true&name=OrderList"

import "./OrderList.vue?vue&type=style&index=0&id=3fb0d5d2&scoped=true&lang=stylus"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb0d5d2"]])

export default __exports__